import {
  getErrorStatus,
  type InterceptedError,
} from '@/shared/api/intercepted-error';
import { isBackendUnavailable } from '@/shared/lib/utils/is-backend-unavailable';
import { requestError } from '@/shared/ui/notifications';
import { type DefaultOptions } from '@tanstack/react-query';

export const queryClientDefaults: DefaultOptions = {
  mutations: {
    onError(e: InterceptedError) {
      if (getErrorStatus(e) !== 401) {
        requestError(e);
      }
    },
  },
  queries: {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    cacheTime: 0,
    useErrorBoundary: isBackendUnavailable,
    retry: (failureCount, error: InterceptedError) => {
      if (isBackendUnavailable(error)) {
        return failureCount < 1;
      }

      const status = getErrorStatus(error);
      if (status === 404 || status === 401 || status === 403) {
        return false;
      }
      if (status === 503) {
        if (failureCount < 3) {
          return true;
        } else {
          requestError(error);
          return false;
        }
      }
      if (status && [500, 422, 424].includes(status)) {
        requestError(error);
        return false;
      }
      return failureCount < 10;
    },
    retryDelay: (failureCount, error: InterceptedError) => {
      if (isBackendUnavailable(error)) {
        return Math.min(1000 * 2 ** failureCount, 4000);
      }
      return 1000;
    },
  },
};
